import { StorageDbConfig } from '../../types';
import { Inject, Injectable } from '@angular/core';
import { STORAGE_DB_CONFIG } from '../../types/providers-config';
import Dexie from 'dexie';
import { cloneDeep } from 'lodash';

@Injectable({ providedIn: 'root' })
export class StorageDbService {
  storageDbConfig: StorageDbConfig;
  private db: Dexie;

  constructor(@Inject(STORAGE_DB_CONFIG) storageDbConfig: StorageDbConfig) {
    this.db = new Dexie(storageDbConfig.name);
    this.storageDbConfig = cloneDeep(storageDbConfig);
    this.db
      .version(storageDbConfig.version)
      .stores(this.storageDbConfig.tables);
  }

  public async getAllTableItems<T>(tableName: string): Promise<T[]> {
    const table = this.db._allTables[tableName] as Dexie.Table;
    return table.toArray();
  }
  public async addTableItem<T>(entry: T, tableName: string): Promise<T> {
    const table = this.db._allTables[tableName] as Dexie.Table;
    const createdId = await table.add(entry);
    return cloneDeep({
      ...entry,
      id: createdId,
    });
  }

  public async putTableItem<T>(
    id: number,
    entry: T,
    tableName: string,
  ): Promise<T> {
    const table = this.db._allTables[tableName] as Dexie.Table;
    await table.put({ ...entry, id: id });
    return cloneDeep({ ...entry, id: id });
  }

  public async clearTableItems<T>(tableName: string): Promise<void> {
    const table = this.db._allTables[tableName] as Dexie.Table;
    return table.clear();
  }
}
